<template>
  <VCard class="pa-2 rounded-lg border" elevation="8" height="100%">
    <VCardTitle>Contract Control </VCardTitle>
  </VCard>
</template>
